import { gql } from "@apollo/client";

// Everything here is scoped by event_id — reports_transactions is a large
// denormalized view and unscoped queries (even distinct_on) blow through
// Hasura's 61s tenant time limit. The aggregate sizes the pull; the skinny
// rows are paginated by offset and reduced client-side (Hasura has no
// group-by, and the per-event row counts — low tens of thousands — transfer
// in well under a second).
export const GET_EVENT_TXN_AGGREGATE = gql`
  query VendorInsightsAggregate($eventId: Int!) {
    reports_transactions_aggregate(
      where: {
        event_id: { _eq: $eventId }
        transaction_status: { _eq: "approved" }
      }
    ) {
      aggregate {
        count
        sum {
          transaction_amount
          tip
        }
      }
    }
    events_by_pk(id: $eventId) {
      id
      name
      start_date
      end_date
      timezone
      timezone_diff
    }
  }
`;

export const GET_EVENT_TXN_ROWS = gql`
  query VendorInsightsRows($eventId: Int!, $limit: Int!, $offset: Int!) {
    reports_transactions(
      where: {
        event_id: { _eq: $eventId }
        transaction_status: { _eq: "approved" }
      }
      order_by: [{ transaction_date: asc }, { order_id: asc }]
      limit: $limit
      offset: $offset
    ) {
      transaction_hour
      transaction_amount
      tip
      payment_type
      vendor_name
      location_name
      device_app_id
      order_items_count
    }
  }
`;
